export default [
  {
    path: '/admin/users',
    name: 'indexUsersAdmin',
    meta: { title: 'indexUsersAdmin' },
    component: () => import('@/pages/admin/users'),
  },
  {
    path: "/admin/users/create",
    name: "createUserAdmin",
    meta: { title: 'createUserAdmin' },
    component: () => import('@/pages/admin/users/create'),
  },
  {
    path: "/admin/users/:id/edit",
    name: "editUserAdmin",
    meta: { title: 'editUserAdmin' },
    component: () => import('@/pages/admin/users/edit'),
  },
]
